import React from 'react';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import { withRouter } from 'react-router-dom';
import { Fixed, Overlay } from 'rebass';
import { compose, withState, withProps } from 'recompose';
import Button from './button';
import Form from './form';
import Success from './success';

const SUCCESS_QUERY_PARAM_KEY = 'thanks';

const Lead = (props) => {
  const {
    children,
    showLeadForm,
    setShowLeadForm,
    submitLeadFormPath,
    showSuccess,
    closeSuccess,
  } = props;

  return (
    <div>
      <Button onClick={() => setShowLeadForm(true)}>
        {children}
      </Button>
      <div style={{ display: showLeadForm || showSuccess ? 'block' : 'none' }}>
        <Fixed
          top
          right
          bottom
          left
          onClick={() => setShowLeadForm(false)}
        />
        <Overlay
          p={0}
          w={['100%', '80%', '600px']}
          style={{ zIndex: 1, borderRadius: 0 }}
        >
          <div style={{ display: showLeadForm ? 'block' : 'none' }}>
            <Form
              close={() => setShowLeadForm(false)}
              action={submitLeadFormPath}
            />
          </div>
          <div style={{ display: showSuccess ? 'block' : 'none' }}>
            <Success close={closeSuccess} />
          </div>
        </Overlay>
      </div>
    </div>
  );
};

Lead.propTypes = {
  children: PropTypes.node,
  showLeadForm: PropTypes.bool.isRequired,
  setShowLeadForm: PropTypes.func.isRequired,
  submitLeadFormPath: PropTypes.string.isRequired,
  showSuccess: PropTypes.bool.isRequired,
  closeSuccess: PropTypes.func.isRequired,
};

Lead.defaultProps = {
  children: 'Let\'s talk about your project',
};

export default compose(
  withState('showLeadForm', 'setShowLeadForm', false),
  // FIXME: hack to short-circuit when success is closed,
  // as location is not updated on location.search change.
  withState('showSuccessState', 'setShowSuccessState', true),
  withRouter,
  withProps(props => {
    const { history, location, showSuccessState, setShowSuccessState } = props;
    const search = location.search;
    const queryParams = queryString.parse(search);

    const showSuccess = showSuccessState && queryParams[SUCCESS_QUERY_PARAM_KEY] !== undefined;

    const queryParamsWithThanks = {
      ...queryParams,
      [SUCCESS_QUERY_PARAM_KEY]: null,
    };
    const submitLeadFormPath = [
      location.pathname,
      queryString.stringify(queryParamsWithThanks),
    ].join('?');

    const closeSuccess = () => {
      const queryParamsWithoutThanks = {
        ...queryParams,
        [SUCCESS_QUERY_PARAM_KEY]: undefined,
      };
      history.replace({
        pathname: location.pathname,
        search: queryString.stringify(queryParamsWithoutThanks),
      });
      setShowSuccessState(false);
    };

    return {
      showSuccess,
      submitLeadFormPath,
      closeSuccess,
    };
  }),
)(Lead);



// WEBPACK FOOTER //
// ./src/Lead/index.js